import { Building2, Home, KeyRound, LineChart, ShieldCheck, Sparkles } from "lucide-react";

export const services = [
    {
        id: "s1",
        icon: Building2,
        name: "Commercial Brokerage",
        blurb: "Institutional-grade representation across office, industrial, retail, hospitality, and mixed-use.",
    },
    {
        id: "s2",
        icon: Home,
        name: "Luxury Residential",
        blurb: "Private-client representation for multi-million-dollar estates, penthouses, and new-development reservations.",
    },
    {
        id: "s3",
        icon: KeyRound,
        name: "Leasing & Tenant Rep",
        blurb: "Lease negotiation, portfolio strategy, and corporate relocation across Southern Nevada.",
    },
    {
        id: "s4",
        icon: LineChart,
        name: "Investment Advisory",
        blurb: "Capital markets, acquisitions, dispositions, 1031 exchanges, and underwriting for family offices and funds.",
    },
    {
        id: "s5",
        icon: ShieldCheck,
        name: "Property Administration",
        blurb: "White-glove post-close administration — vendor coordination, concierge, and asset stewardship.",
    },
    {
        id: "s6",
        icon: Sparkles,
        name: "Off-Market & Discreet",
        blurb: "Silent-market curation for UHNW clients — listings that never see public MLS.",
    },
];
